import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'eventq-popover-search',
  imports: [MatIcon],
  templateUrl: './popover-search.html',
  styleUrl: './popover-search.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqPopoverSearch {
  readonly placeholder = input('Search');
  readonly value = input('');

  readonly valueChange = output<string>();

  onInput(event: Event): void {
    this.valueChange.emit((event.target as HTMLInputElement).value);
  }
}
